import { render } from "./ToastSafariInstallation.vue?vue&type=template&id=33c8fc3e"
import script from "./ToastSafariInstallation.vue?vue&type=script&lang=js"
export * from "./ToastSafariInstallation.vue?vue&type=script&lang=js"

import "./ToastSafariInstallation.vue?vue&type=style&index=0&id=33c8fc3e&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ToastSafariInstallation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33c8fc3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33c8fc3e', __exports__)) {
    console.log('reload')
    api.reload('33c8fc3e', __exports__)
  }
  
  module.hot.accept("./ToastSafariInstallation.vue?vue&type=template&id=33c8fc3e", () => {
    console.log('re-render')
    api.rerender('33c8fc3e', render)
  })

}


export default __exports__